import React, { useState } from "react";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import CreatableSelect from 'react-select/creatable';

const InputField = ({ label, onChange, type = "text", placeholder, maxLength, required = false, value, error }) => (
  <div className="form-group">
    <label className="form-label">
      {label} {required && <span style={{ color: "red" }}>*</span>}
    </label>
    <input
      onChange={onChange}
      className={`form-control form-control-acc mb-2 ${error ? "is-invalid" : ""}`}
      type={type}
      placeholder={placeholder}
      maxLength={maxLength}
      value={value}
    />
    {error && <div className="invalid-feedback">{error}</div>}
  </div>
);

const SelectField = ({ label, onChange, options, required = false }) => (
  <div className="form-group">
    <label className="form-label">
      {label} {required && <span style={{ color: "red" }}>*</span>}
    </label>
    <select onChange={onChange} className="form-control">
      <option value={null}>----</option>
      {options.map((option) => (
        <option value={option.id} key={option.id}>
          {option.categorie}
        </option>
      ))}
    </select>
  </div>
);

const CandidateInfo = ({
  category,
  handleNomPrenom,
  handlePrenom,
  handlePoste,
  handleSousCat,
  handleAExp,
  handleEmail,
  handleCodeCall,
  handleTelephone,
  handleTelephone1,
  handleTelephone2,
  handleAge,
  handleAdress,
  handleFacebook,
  handleLinkedin,
  handlePretention,
  handleDispo,
  handledateDispo,
  handleContrat,
  handleNation,
  handleNationnalite,
  dispo,
}) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [birthYear, setBirthYear] = useState("");
  const [birthYearError, setBirthYearError] = useState("");
  const [pretention, setPretention] = useState("");
  const [pretentionError, setPretentionError] = useState("");

  const alpha = [
    {"id": 3,"categorie": "Finance et Comptabilité",},
    {"id": 7,"categorie": "Informatique et Systèmes d'Information",},
    {"id": 5,"categorie": "Marketing et Communication",},
    {"id": 8,"categorie": "Production et Logistique",},
    {"id": 9,"categorie": "Qualité et Contrôle",},
    {"id": 12,"categorie": "Rédaction web",},
    {"id": 4,"categorie": "Ressources Humaines",},
    {"id": 2,"categorie": "Secrétaire de Direction",},
    {"id": 10,"categorie": "Service Client",},
    {"id": 11,"categorie": "Stratégie et Développement",},
    {"id": 1,"categorie": "Télésecretaire Médical",},
    {"id": 6,"categorie": "Ventes et Commercial",}
  ];

  const sousCat = [
    {"id": 1,"categorie": "Directeur Financier (CFO)","categorie_cv_id": 3,},
    {"id": 2,"categorie": "Comptable","categorie_cv_id": 3,},
    {"id": 3,"categorie": "Directeur des Ressources Humaines (DRH)","categorie_cv_id": 4,},
    {"id": 4,"categorie": "Responsable RH","categorie_cv_id": 4,},
    {"id": 5,"categorie": "Recruteur","categorie_cv_id": 4,},
    {"id": 6,"categorie": "Gestionnaire de Paie","categorie_cv_id": 4,},
    {"id": 7,"categorie": "Formation et Développement","categorie_cv_id": 4,},
    {"id": 8,"categorie": "Directeur Marketing","categorie_cv_id": 5,},
    {"id": 9,"categorie": "Chef de Projet Marketing","categorie_cv_id": 5,},
    {"id": 10,"categorie": "Community Manager","categorie_cv_id": 5,},
    {"id": 11,"categorie": "Spécialiste SEO/SEM","categorie_cv_id": 5,},
    {"id": 12,"categorie": "Directeur Commercial","categorie_cv_id": 6,},
    {"id": 13,"categorie": "Télévendeur","categorie_cv_id": 6,},
    {"id": 14,"categorie": "Directeur Informatique (CIO)","categorie_cv_id": 7,},
    {"id": 15,"categorie": "Développeur Web","categorie_cv_id": 7,},
    {"id": 16,"categorie": "Administrateur Réseaux","categorie_cv_id": 7,},
    {"id": 17,"categorie": "Ingénieur Sécurité","categorie_cv_id": 7,},
    {"id": 18,"categorie": "Chef de Projet IT","categorie_cv_id": 7,},
    {"id": 19,"categorie": "Responsable Logistique","categorie_cv_id": 8,},
    {"id": 20,"categorie": "Contrôleur Qualité","categorie_cv_id": 9,},
    {"id": 21,"categorie": "Auditeur Qualité","categorie_cv_id": 9,},
    {"id": 22,"categorie": "Conseiller Clientèle","categorie_cv_id": 10,},
    {"id": 23,"categorie": "Chef de Projet Développement","categorie_cv_id": 11,},
    {"id": 24,"categorie": "Analyste","categorie_cv_id": 7,}
  ]

  // const [poste, setPoste] = useState("");

  // const postesOptions = [
  //   {value: 3, label: "Finance et Comptabilité",},
  //     {value: 7, label: "Informatique et Systèmes d'Information",},
  //     {value: 5, label: "Marketing et Communication",},
  //     {value: 8, label: "Production et Logistique",},
  //     {value: 9, label: "Qualité et Contrôle",},
  //     {value: 12, label: "Rédaction web",},
  //     {value: 4, label: "Ressources Humaines",},
  //     {value: 2, label: "Secrétaire de Direction",},
  //     {value: 10, label: "Service Client",},
  //     {value: 11, label: "Stratégie et Développement",},
  //     {value: 1, label: "Télésecretaire Médical",},
  //     {value: 6, label: "Ventes et Commercial",}
  // ];

  // const handleChange = (newValue) => {
  //   setPoste(newValue);
  // };

  const validateEmail = (e) => {
    const value = e.target.value;
    setEmail(value);
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(value)) {
      setEmailError("Format d'e-mail invalide");
    } else {
      setEmailError("");
      handleEmail(e);
    }
  };

  const validateBirthYear = (e) => {
    const value = e.target.value;
    setBirthYear(value);
    const yearPattern = /^(19|20)\d{2}$/;
    if (!yearPattern.test(value)) {
      setBirthYearError("Format d'année invalide");
    } else {
      setBirthYearError("");
      handleAge(e);
    }
  };

  const validatePretention = (e) => {
    const value = e.target.value;
    setPretention(value);
    handlePretention(e);
    // if (isNaN(value)) {
    //   setPretentionError("La prétention salariale doit être un nombre");
    // } else {
    //   setPretentionError("");
    //   handlePretention(e);
    // }
  };

  return (
    <div className="card mb-grid">
      <div className="card-header">
        <div className="card-header-title">À propos du candidat</div>
      </div>
      <div className="card-body">
        <form>
          <div className="row">
            <div className="col-sm-6">
              <InputField label="Nom" onChange={handleNomPrenom} placeholder="Votre nom" maxLength={30} required />
            </div>
            <div className="col-sm-6">
              <InputField label="Prénom" onChange={handlePrenom} placeholder="Votre prénom" maxLength={30} required />
            </div>
          </div>
          <div className="row">
          <div className="col-sm-6">
          {/* <CreatableSelect
            isClearable
            options={postesOptions}
            value={poste}
            onChange={handleChange}
            placeholder="Sélectionner ou écrire un poste"
          /> */}
            <SelectField label="Poste" onChange={handlePoste} options={alpha} required />
          {/* {category && <SelectField label="Autre poste" onChange={handleSousCat} options={sousCat} />} */}
          </div>
          <div className="col-sm-6">
          <SelectField
            label="Combien d'années sur ce poste"
            onChange={handleAExp}
            options={Array.from({ length: 10 }, (_, i) => ({ id: i + 1, categorie: `${i} ${i === 1 ? 'an' : 'ans'}` })).concat({ id: 11, categorie: '+ de 5 ans' }, { id: 12, categorie: '+ de 10 ans' })}
            required
          />
          </div>
          </div>

          <InputField label="E-mail" onChange={validateEmail} placeholder="Votre e-mail" value={email} error={emailError} required />
          
          {/* Telephone inputs */}
          <div className="row">
          {Array.from({ length: 3 }, (_, index) => (
             <div className="col-md-4">
            <div className="form-group" key={index}>
              <label className="form-label">{index === 0 ? "Téléphone" : "Autre Téléphone"}</label>
              <div className="input-group">
                <PhoneInput
                  country={'mg'}
                  inputProps={{
                    name: 'tel',
                    required: true,
                    autoFocus: true
                  }}
                  onChange={index === 0 ? handleTelephone : index === 1 ? handleTelephone1 : handleTelephone2}
                  inputStyle={{width: "210px"}}
                />
              </div>
            </div>
            </div>
          ))}
          </div>
          
          <InputField label="Année de naissance" onChange={validateBirthYear} placeholder="Année de votre naissance" maxLength={4} value={birthYear} error={birthYearError} required />
          <InputField label="Adresse exacte" onChange={handleAdress} placeholder="Votre adresse exacte" required />
          <div className="row">
            <div className="col-sm-6"><InputField label="Facebook" onChange={handleFacebook} placeholder="Lien de votre profil Facebook" /></div>
            <div className="col-sm-6"><InputField label="LinkedIn" onChange={handleLinkedin} placeholder="Lien de votre profil LinkedIn" /></div>
          </div>

          <div className="form-group">
            <label className="form-label">Prétention salariale</label>
            <div className="input-group">
              <input
                onChange={validatePretention}
                maxLength={50}
                className="form-control input-prefix mb-2 h42"
                type="text"
                placeholder="Votre prétention salariale"
                value={pretention}
                error={pretentionError}
              />
              {pretentionError && <div className="invalid-feedback">{pretentionError}</div>}
            </div>
          </div>

          <SelectField label="Disponibilité" onChange={handleDispo} options={[
            { id: 'Disponible immediat', categorie: 'Disponible immédiat' },
            { id: 'preavis', categorie: 'Disponible avec préavis' },
            { id: 'enposte', categorie: 'En poste' },
          ]} required />
          
          {dispo === 'Disponible avec préavis' && (
            <InputField label="Date de disponibilité" onChange={handledateDispo} type="date" required />
          )}

          <SelectField label="Type de contrat" onChange={handleContrat} options={[
            { id: 'CDI', categorie: 'CDI' },
            { id: 'CDD', categorie: 'CDD' },
          ]} required />

          <div className="row">
          <div className="col-sm-6">
          <SelectField label="Localisation" onChange={handleNation} options={[
            { id: 'Madagascar', categorie: 'Madagascar' },
            { id: 'Maurice', categorie: 'Maurice' },
            { id: 'Autre', categorie: 'Autre résident' },
          ]} required />
          </div>
          <div className="col-sm-6">
          <SelectField label="Nationalité" onChange={handleNationnalite} options={[
            { id: 'Malgache', categorie: 'Malgache' },
            { id: 'Mauricen', categorie: 'Mauricen' },
            { id: 'Autre', categorie: 'Autre nationalité' },
          ]} required />
          </div>
          </div>

          <p>
            Tous les champs avec du <span style={{ color: "red" }}>*</span> sont obligatoires
          </p>
        </form>
      </div>
    </div>
  );
};

export default CandidateInfo;
